// extracted by mini-css-extract-plugin
export default {"container":"A5uq4u"};